import { render, staticRenderFns } from "./VersionPage.vue?vue&type=template&id=58a37b1c&scoped=true"
import script from "./VersionPage.vue?vue&type=script&lang=js"
export * from "./VersionPage.vue?vue&type=script&lang=js"
import style0 from "./VersionPage.vue?vue&type=style&index=0&id=58a37b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a37b1c",
  null
  
)

export default component.exports